import {groupByUniqueKey} from '@benchling/js-utils';

import {PolymerSubtype} from 'constants/MolbioConstants';
import {SequenceTopology} from 'constants/SequenceConstants';
import {FragmentProductionMethod, MethodData} from 'molbio/bulk-assembly/BulkAssemblyConstants';
import {FragmentModalFragment} from 'molbio/bulk-assembly/polymer-map-modals/FragmentCardContents';
import {constructFragmentData} from 'molbio/bulk-assembly/util/BulkAssemblyUtil';

export async function updateFragmentsData(
  itemIds: Array<string>,
  fragmentsData: Array<FragmentModalFragment>,
  setFragmentsData: (fragmentsData: Array<FragmentModalFragment>) => void,
  metadata: {
    polymerSubtypes: Array<PolymerSubtype>;
    enableSelectPreferredPrimers: boolean;
    binCid: string;
    binColor: string;
    binIndex: number;
    constructFragmentIndex: number;
    canSpecifyEndpoints: boolean;
    constructTopology: SequenceTopology;
    numConstructFragments: number;
    bulkAssemblyMethodData: MethodData;
    fragmentProductionMethod: FragmentProductionMethod;
    canUpdateRestrictionEnzymes: boolean;
  }
): Promise<void> {
  // Use the existing fragment data if it already exists (a user already started defining the fragments and then clicked back).
  // Otherwise, create a fresh fragment data object.
  const existingFragmentData = groupByUniqueKey(fragmentsData, (fragmentData) => fragmentData.polymerId);
  const {
    polymerSubtypes,
    enableSelectPreferredPrimers,
    binCid,
    binColor,
    binIndex,
    constructFragmentIndex,
    canSpecifyEndpoints,
    constructTopology,
    numConstructFragments,
    bulkAssemblyMethodData,
    fragmentProductionMethod,
    canUpdateRestrictionEnzymes,
  } = metadata;
  const currentFragmentsData = await Promise.all(
    itemIds.map(
      (itemId) =>
        existingFragmentData[itemId] ??
        constructFragmentData({
          polymerId: itemId,
          polymerKind: polymerSubtypes[0] === PolymerSubtype.aa_sequence ? 'protein' : 'sequence',
          expectedVersionDbId: null,
          showPrimerSearch: enableSelectPreferredPrimers,
          color: binColor,
          binCid,
          binIndex,
          constructFragmentIndex,
          canSpecifyEndpoints,
          constructTopology,
          numFragmentBins: numConstructFragments,
          assemblyMethod: bulkAssemblyMethodData,
          fragmentProductionMethod,
          canUpdateRestrictionEnzymes,
        })
    )
  );

  setFragmentsData(currentFragmentsData);
}
